var map = {
	"./archeology.svg": 8609,
	"./beach.svg": 8703,
	"./bike.svg": 7041,
	"./brewery.svg": 3960,
	"./bridge.svg": 869,
	"./building.svg": 5366,
	"./bunker.svg": 9985,
	"./cable_car.svg": 5958,
	"./canyon.svg": 6782,
	"./car_overlook.svg": 7868,
	"./castle.svg": 502,
	"./cave.svg": 1705,
	"./cementary.svg": 5732,
	"./church.svg": 3847,
	"./church_wood.svg": 1277,
	"./city.svg": 7827,
	"./cross.svg": 5866,
	"./dam.svg": 7168,
	"./horse.svg": 1937,
	"./kayak.svg": 1779,
	"./lake.svg": 9047,
	"./lighthouse.svg": 6062,
	"./marina.svg": 4128,
	"./monument.svg": 7301,
	"./mountain.svg": 6623,
	"./museum.svg": 2050,
	"./overlook.svg": 5213,
	"./palace.svg": 7710,
	"./park.svg": 5346,
	"./quarry.svg": 2338,
	"./restaurant.svg": 503,
	"./ski.svg": 3685,
	"./stones.svg": 192,
	"./swimming_pool.svg": 1510,
	"./technical.svg": 5699,
	"./theme_park.svg": 6419,
	"./thermae.svg": 5094,
	"./ticket.svg": 2566,
	"./tower.svg": 6233,
	"./train.svg": 3972,
	"./trekking.svg": 3557,
	"./tunnel.svg": 7480,
	"./underground_path.svg": 5073,
	"./urbex.svg": 4844,
	"./village.svg": 206,
	"./waterfall.svg": 4236,
	"./windmill.svg": 5586,
	"./wine.svg": 5125,
	"./zoo.svg": 5486
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7604;